import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { Prompt } from 'react-router-dom';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';

const QuestionActionListItemComponent = ({
  questionAction,
  questionActionTypes,
  index,
  collectionValidation,
  isReadOnly,
  onPropertyChanged
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Prompt
        when={questionAction.changed && !isReadOnly}
        message={t('Questionnaire.LeavingWithoutSavingQuestionAction', { index: index + 1 })}
      />
      <Grid item container spacing={2}>
        <Grid item xs={12} sm={3}>
          <Autocomplete
            fullWidth
            value={questionAction.questionActionTypeId}
            options={questionActionTypes}
            onChange={event => onPropertyChanged('questionActionTypeId', event, index)}
            simpleValue
            label={t('Questionnaire.QuestionAction.QuestionActionType')}
            error={!isValid(collectionValidation[index].questionActionTypeId)}
            helperText={getErrors(collectionValidation[index].questionActionTypeId)}
            disabled={isReadOnly}
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            fullWidth
            value={questionAction.formula || ''}
            onChange={event => onPropertyChanged('formula', event, index)}
            label={t('Questionnaire.QuestionAction.Formula')}
            disabled={isReadOnly}
            error={!isValid(collectionValidation[index].formula)}
            helperText={getErrors(collectionValidation[index].formula)}
          />
        </Grid>
      </Grid>
    </>
  );
};

QuestionActionListItemComponent.propTypes = {
  questionAction: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  questionActionTypes: PropTypes.array,
  collectionValidation: PropTypes.object.isRequired,
  isReadOnly: PropTypes.bool,
  onPropertyChanged: PropTypes.func.isRequired
};
export default QuestionActionListItemComponent;
